import type {ActionResponseWithText, Document, Exemplar, LoanRequestFormActionResponse, LoanRequestItem, LoanRequestTypes, RedirectionResponse} from 'src/typings';
import type LoanRequestDataService from './loan-request.data-service';
import {ngAsync} from 'shared/utils/ng-@decorators';

/**
 * @ngdoc service
 * @name loanRequestService
 * @module portaro.services
 *
 * @description
 * Service for loaning Documents and Exemplars
 */
export default class LoanRequestService {
    public static readonly serviceName = 'loanRequestService';

    /*@ngInject*/
    constructor(private loanRequestDataService: LoanRequestDataService) {
    }

    @ngAsync()
    public async requestLoan(pathWithoutApiPrefix: string, loanRequest: LoanRequestTypes): Promise<ActionResponseWithText> {
        return this.loanRequestDataService.requestLoan(pathWithoutApiPrefix, loanRequest);
    }

    @ngAsync()
    public async requestDocument(document: Document): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        return this.request([{document}]);
    }

    @ngAsync()
    public async requestDocuments(documents: Document[]): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        const items = documents.map((document) => ({document}));
        return this.request(items);
    }

    @ngAsync()
    public async requestExemplar(exemplar: Exemplar): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        return this.request([{exemplar}]);
    }

    @ngAsync()
    public async request(items: LoanRequestItem[]): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        return this.loanRequestDataService.requestLoanForm(items);
    }
}
